const chips = ["文字提取", "图片提取", "视频解析", "链接提取", "数据抓取", "源码查看"];

const stats = [
  { num: "6 大", label: "核心提取能力" },
  { num: "秒级", label: "快速解析反馈" },
  { num: "免安装", label: "打开即用无需登录" },
  { num: "本地化", label: "内容自主保存不代管" },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[720px] w-full items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20background%20with%20flowing%20layers%20of%20terracotta%20coral%20red%2C%20ripe%20melon%20green%20and%20cream%20tone%2C%20soft%20fluid%20gradient%20waves%2C%20dark%20moody%20cinematic%20lighting%2C%20minimal%20organic%20shapes%2C%20high%20detail%2C%20sophisticated%20modern%20design%20texture&width=1600&height=900&seq=hero-chigua-bg&orientation=landscape"
          alt="吃瓜网页提取工具的暖色调抽象背景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-background-950/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent" />
      </div>

      <div className="container-x relative w-full py-24 pt-28 md:py-28">
        <div className="max-w-3xl">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 backdrop-blur-sm">
            <i className="ri-sparkling-2-fill text-accent-300 text-sm" aria-hidden="true" />
            <span className="text-xs text-background-50/90 md:text-sm">网页素材提取 · 内容解析工具</span>
          </div>

          <h1 className="font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            一条链接，
            <span className="text-accent-300">扒尽网页素材</span>
          </h1>

          <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-50/80 md:text-lg">
            吃瓜网页帮你把页面里的文字、图片、视频、链接与数据一次性提取出来。输入链接、
            选择类型，吃瓜好料与重点资料即刻收进口袋，想看源码也能一眼到底。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#demo"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3.5 text-sm whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
            >
              立即免费体验
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
            <a
              href="#features"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-background-50/35 px-7 py-3.5 text-sm whitespace-nowrap text-background-50 transition-colors hover:bg-background-50/10"
            >
              查看功能介绍
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {chips.map((c) => (
              <span
                key={c}
                className="inline-flex items-center gap-1.5 rounded-full border border-background-50/20 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-50/90 backdrop-blur-sm"
              >
                <i className="ri-checkbox-circle-line text-accent-300 text-sm" aria-hidden="true" />
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0">
        <div className="container-x">
          <div className="grid grid-cols-2 gap-px overflow-hidden rounded-t-2xl border border-b-0 border-background-50/15 bg-background-50/10 backdrop-blur-md lg:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center justify-center gap-1 px-4 py-5 text-center">
                <span className="font-heading text-2xl text-background-50 md:text-3xl">{s.num}</span>
                <span className="text-xs text-background-50/70 md:text-sm">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}